<template>
  <a target="_blank" :href="attachment.link" class="message link">
    {{ attachment.text }}
    <fai class="icon" icon="arrow-up-right-from-square" />
  </a>
</template>
<script setup>
const props = defineProps({
  message: {
    type: Object,
    required: false,
  },
  attachment: {
    type: Object,
    required: false,
    default: {},
  },
});
</script>
